import { Button } from '@realtyka/real-ui';
import React from 'react';
import useDeviceType from '../../../hooks/useDeviceType';

interface MfaSetupCardProps {
  onSetupClick: () => void;
}

const MfaSetupCard: React.FC<MfaSetupCardProps> = ({ onSetupClick }) => {
  const { isMobile } = useDeviceType();
  return (
    <div className='mt-2'>
      <div className='flex flex-col gap-y-2 w-full mb-6'>
        <div className='text-reskin-primary-dark text-center text-sm md:text-base font-inter-regular'>
          Before you continue you need to add a second step verification to
          protect your account
        </div>
        <div className='text-reskin-grey-600 text-center text-xs font-inter-light pt-4 md:pt-0'>
          Two-factor authentication (2FA) provides an additional layer of
          security beyond passwords and is strongly recommended. Once enabled,
          your account is protected by requiring both your password and an
          authentication code from an authenticator app or your mobile device in
          order to log in to Rezen.
        </div>
      </div>
      <div className='flex flex-col gap-y-2 w-full'>
        <Button
          variant='filled'
          size={isMobile ? 'sm' : 'md'}
          type='submit'
          fullWidth
          color='primary'
          onClick={onSetupClick}
        >
          <div className='font-medium'>Set-Up Two-Factor Authentication</div>
        </Button>
      </div>
    </div>
  );
};

export default MfaSetupCard;
